/* eslint-disable @typescript-eslint/no-non-null-assertion */
import * as React from 'react';
import { useSelector } from 'react-redux';
import { ChartWrapper, PriceChart, SalesChart } from '../../../components/RealtyValuation';
import { getRealtyValuation } from '../../../selectors/realtyValuation';
import { getRoomOptions } from '../../../selectors/realtyValuation/getRoomOptions';
import { ERoomType, EValuationTabs } from '../../../types/realtyValuation';
import { useDynamicPricesChartCfg, useDynamicSalesChartCfg } from '../../../utils/realtyValuation';
import { trackSelectPriceHistoryRooms } from '../tracking';

interface IChartsProps {
  activeTab: EValuationTabs;
}

export function Charts({ activeTab }: IChartsProps) {
  const [roomType, setRoomType] = React.useState(ERoomType.All);

  const realtyValuation = useSelector(getRealtyValuation)!;

  const pricesChartCfg = useDynamicPricesChartCfg(realtyValuation, roomType);
  const salesChartCfg = useDynamicSalesChartCfg(realtyValuation);

  const onRoomTypeChange = React.useCallback((e, value) => {
    setRoomType(value);
    trackSelectPriceHistoryRooms();
  }, []);

  const roomOptions = getRoomOptions(realtyValuation);

  const getContent = () => {
    if (activeTab === EValuationTabs.PriceDynamic) {
      return (
        <PriceChart
          chartCfg={pricesChartCfg}
          roomType={roomType}
          onChange={onRoomTypeChange}
          roomOptions={roomOptions}
        />
      );
    }

    if (!salesChartCfg) {
      return null;
    }

    return <SalesChart chartCfg={salesChartCfg} />;
  };

  return <ChartWrapper>{getContent()}</ChartWrapper>;
}
